import { render, staticRenderFns } from "./ProcessMenu.vue?vue&type=template&id=0982f98c&scoped=true&"
import script from "./ProcessMenu.vue?vue&type=script&lang=ts&"
export * from "./ProcessMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessMenu.vue?vue&type=style&index=0&id=0982f98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0982f98c",
  null
  
)

export default component.exports